<template>
<div>
  <CreateForm v-if="createForm" :paymentBill="getSalaryAccount" :data="data"
              @close-form="closeCreateForm" @get-sing-code="getActSignScreen"
              @confirm-form="confirmCreateForm"/>
  <SignCode v-else-if="signForm" :data="actData" @edit-button="openEdit"
            @back-button="closeForm" @close-form="closeForm" />
  <PayoutsTable v-else :payouts="getPaymentActs" @get-status="getByStatus"
                @open-edit="openEdit" @close-form="closeForm"
                @show-create="openEdit" />
</div>
</template>

<script>
import PayoutsTable from '@/layouts/components/salaryProject/payouts/payoutsTable'
import CreateForm from '@/layouts/components/salaryProject/payouts/createForm'
import SignCode from '@/layouts/components/salaryProject/payouts/signCode'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Payouts',
  data: () => ({
    payout: {id: null},
    data: null,
    createForm: false,
    signForm: false,
    actData: {}
  }),
  components: {CreateForm, SignCode, PayoutsTable},
  methods: {
    ...mapActions('salary', ['fetchPaymentActs', 'fetchEmployees', 'addPaymentAct', 'getActSign', 'updateAct']),
    setSelected (val) {
      this.employee = val
    },
    confirmCreateForm () {
      this.createForm = false
    },
    closeCreateForm () {
      this.createForm = false
      this.data = null
    },
    async openEdit (row) {
      if (row) {
        this.data = row
      } else if (!this.data) {
        const payload = {
          contact_name: this.userInfo.name,
          contact_phone: this.userInfo.phone,
          act_date: (new Date()),
          type_payment: 0,
          note: ''
        }
        this.data = await this.addPaymentAct(payload)
      }
      this.createForm = true
      this.signForm = false
    },
    async getActSignScreen ({data}) {
      const update = {...data.head, note: data.note}
      if (await this.updateAct({actId: data.head.id, data: update})) {
        data.head.note = data.note
      }
      this.actData = data
      this.signForm = true
      this.createForm = false
    },
    backClick () {
      this.createForm = true
      this.signForm = false
      this.data = null
    },
    closeForm () {
      this.createForm = false
      this.signForm = false
      this.fetchPaymentActs(0)
    },
    async getByStatus (status) {
      await this.fetchPaymentActs(status)
    }
  },
  computed: {
    ...mapGetters('utils', ['getSalaryAccount', 'getUserRole']),
    ...mapGetters('user', ['userInfo']),
    ...mapGetters('salary', ['getPaymentActs'])
  },
  mounted () {
    this.fetchEmployees()
    this.fetchPaymentActs(0)
  }
}
</script>

<style scoped>

</style>
